<!-- The dashboard's workspace pill (tapp-dashboard-v2 components/companySwitcher/Trigger.vue), with a chevron in place of the shortcut on phones -->
<template>
    <button
        type="button"
        class="flex h-10 min-w-0 max-w-full cursor-pointer items-center gap-2 rounded-full bg-system-light pr-3 pl-1.5 text-sm font-semibold text-default shadow-md transition-colors outline-hidden hover:bg-neutral-100 focus-visible:outline-1 focus-visible:-outline-offset-1 focus-visible:outline-solid sm:max-w-[340px] sm:pr-2"
        :aria-label="`Workspace menu for ${workspaceName}`"
    >
        <!-- Sized past the library's xs and sm steps, without the border and shadow, so it sits 6px from the pill's edge -->
        <Avatar alt="Workspace" :initials="initials" class="size-7 shrink-0 border-0 text-xs shadow-none" />
        <span class="min-w-0 truncate">{{ workspaceName }}</span>
        <Badge :label="shortcutLabel" variant="outline" :shadow="false" :border="true" class="shrink-0 max-sm:hidden" />
        <Icon type="chevronDown" class="w-2.5 shrink-0 sm:hidden" />
    </button>
</template>

<script setup lang="ts">
    import { Avatar, Badge, Icon } from '@tapp.online/ui'

    defineProps<{
        shortcutLabel: string
    }>()

    const { activeCompany, workspaceInitials } = useWorkspaceSwitch()

    const workspaceName = computed(() => activeCompany.value?.name ?? 'Select company')
    const initials = computed(() => workspaceInitials(activeCompany.value?.name?.trim()) || '?')
</script>
